import type { AxiosRequestConfig } from 'axios';

import { useClaim } from '../ClaimContainer';
import type { CoverageConfigModel } from '../types/coverage-types';
import useDataFetcher from '../useDataFetcher';

export const useCoverageConfigs = () => {
  const { claim } = useClaim({ claimRequired: true });
  const coverageConfigsParams: AxiosRequestConfig = {
    params: {
      sub_organization_ids: claim.policy?.sub_organization?.id ? [claim.policy.sub_organization.id] : [],
      lob: claim.lob,
      include_disabled: true,
    },
  };
  const {
    isLoading: isCoverageConfigsLoading,
    isError: isCoverageConfigsError,
    data: coverageConfigs = [],
    reloadData,
  } = useDataFetcher<CoverageConfigModel[]>(
    `/api/v1/organizations/${claim.organization_id}/coverage_configs`,
    coverageConfigsParams
  );

  return { isCoverageConfigsLoading, isCoverageConfigsError, coverageConfigs, reloadData };
};

export default useCoverageConfigs;
